import { LiItem } from "@faire/help-center-self-serve/brand/instantAnswers/instantAnswersComponents/common/LiItem";
import retailerSettingsProfile from "@faire/web-api/routes/retailer/settings/profile";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Bold } from "@faire/web/ui/Typography/Span";
import React from "react";
export var ResetOrUpdatePasswordIA = function ResetOrUpdatePasswordIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qQ6HjO",
    defaultMessage: [{
      "type": 0,
      "value": "Je hebt twee opties voor het beheren van je wachtwoord:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4bZNDG",
    defaultMessage: [{
      "type": 0,
      "value": "Stel je wachtwoord opnieuw in als je het bent vergeten:"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1ShK6n",
    defaultMessage: [{
      "type": 0,
      "value": "Klik op "
    }, {
      "children": [{
        "type": 0,
        "value": "Inloggen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " in de rechterbovenhoek van de startpagina"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "A45LYr",
    defaultMessage: [{
      "type": 0,
      "value": "Voer je e-mailadres in en druk op Enter"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "yaYwDM",
    defaultMessage: [{
      "type": 0,
      "value": "Klik op "
    }, {
      "children": [{
        "type": 0,
        "value": "Wachtwoord vergeten? Opnieuw instellen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3dToYM",
    defaultMessage: [{
      "type": 0,
      "value": "Controleer je e-mail (inclusief spam) op een link om je wachtwoord opnieuw in te stellen"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "l36AqR",
    defaultMessage: [{
      "type": 0,
      "value": "Volg de instructies in de e-mail om je wachtwoord opnieuw in te stellen"
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Rp+OL4",
    defaultMessage: [{
      "type": 0,
      "value": "Werk je wachtwoord bij, als je je huidige wachtwoord kent:"
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3bw68g",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar je pagina "
    }, {
      "children": [{
        "type": 0,
        "value": "Instellingen"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }],
    values: {
      AccountSettingLinkFormatting: AccountSettingLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Lv/yn9",
    defaultMessage: [{
      "type": 0,
      "value": "Navigeer naar "
    }, {
      "children": [{
        "type": 0,
        "value": "Mijn profiel"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  })), " "), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EaN/2z",
    defaultMessage: [{
      "type": 0,
      "value": "Zoek het gedeelte "
    }, {
      "children": [{
        "type": 0,
        "value": "Wachtwoord"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " en volg de aanwijzingen om je wachtwoord te wijzigen."
    }],
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nUHkRv",
    defaultMessage: [{
      "type": 0,
      "value": "Als je problemen hebt met het opnieuw instellen of bijwerken van je wachtwoord, neem dan contact met ons op via de onderstaande opties."
    }]
  })));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var AccountSettingLinkFormatting = function AccountSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: retailerSettingsProfile(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};